import React, { Component } from "react";
import { connect } from "react-redux";
import "./view-assignment.css";
import "./MobileExplanationPanel.css";
import { Modal, Button, Alert } from "react-bootstrap";
import MaterialIcon from "react-google-material-icons";
import Rater from "react-rater";

class MobileExplanationPanel extends Component {
  constructor(props) {
    super(props);
    this.isCorrect = this.props.isCorrect;
    this.nextQuestion = this.props.nextQuestion;
    // this.translationButton = this.props.translationButton
    this.state = {
      showPanel: true,
      currentQuestion: this.props.question,
      explanation: this.props.explanation
    };
  }


  componentDidUpdate(prevProps) {

    if (prevProps.explanation !== this.props.explanation || prevProps.question !== this.props.question) {
      this.setState({ currentQuestion: this.props.question, explanation: this.props.explanation });
    }
  }

  render() {
    let explanation_box = (
      <Modal
        id="mobile-panel"
        show={this.state.showPanel}
        onHide={this.nextQuestion}
        container={this}
      >
        <Modal.Header
          id={this.isCorrect ? "heading-blue" : "heading-red"}
          closeButton
        >
          <Modal.Title>
            <div className="answer">
              {this.isCorrect ? (
                <h3><MaterialIcon icon="check_circle" size={16} />Correct Answer</h3>
              ) : (
                  <div>
                    <h3><MaterialIcon icon="cancel" size={16} />InCorrect Answer</h3>
                    <p>
                      Correct Answer is:
                    <span>{this.props.parser.parse(this.state.currentQuestion.answer)}</span>
                    </p>
                  </div>
                )}
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{this.state.explanation}</p>
        </Modal.Body>

        <Modal.Footer>
          <div className="pull-left stars">How would you rate this explanation?<Rater rating={this.state.currentRating} onRate={this.onRate} /></div>
          <Button variant="primary" className="pull-right" bsStyle='primary' onClick={this.nextQuestion}>
            Next Question
          </Button>
          {this.props.translationButton(this.state.currentQuestion, this.isCorrect)}
        </Modal.Footer>
      </Modal>
    );
    return explanation_box;
  }
}

function mapStateToProps(state = {}) {
  return { ...state };
}

export default connect(mapStateToProps)(MobileExplanationPanel);
